import type { ReactNode } from 'react';
import { signInHref } from '../api/client';
import { COLUMN_ORDER, COLUMN_TONE } from '../components/Bits';
import { Brand, FRAME, MAIN, TOPBAR, ThemeToggle } from '../components/Shell';
import { buttonClass, cn } from '../components/ui';
import { signInLabel } from '../lib/signin';

/** The signed-out and no-workspace pages' frame: the top bar and a centred hero. */
export function Hero({ children }: { children: ReactNode }) {
  return (
    <div className={FRAME}>
      <header className={TOPBAR}>
        <Brand />
        <span className="flex-1" />
        <ThemeToggle />
      </header>
      <main className={cn(MAIN, 'items-center justify-center px-4 py-8')}>
        <section className="grid max-w-[34rem] gap-3.5 [&_h1]:m-0 [&_h1]:text-[26px] [&_h1]:leading-[1.2] [&_h1]:tracking-[-0.025em] [&_h1]:text-balance [&_p]:m-0 [&_p]:text-[15px]">
          {children}
        </section>
      </main>
    </div>
  );
}

/** Signed out: what the board is, and the one way in. */
export function Landing({ next = '/' }: { next?: string }) {
  return (
    <Hero>
      <div className="grid grid-cols-6 gap-1.5" aria-hidden="true">
        {COLUMN_ORDER.map((c) => (
          <i key={c} className={cn('block h-[3px] rounded-[2px]', COLUMN_TONE[c].hue)} />
        ))}
      </div>
      <h1>Plans, bugs and pull requests in one place</h1>
      <p>
        A read-only kanban over your meta repos: every plan, bug batch, chore, bug and pull request, placed in its
        lifecycle column, on desktop and phone.
      </p>
      <p>
        <a className={buttonClass('primary', 'lg')} href={signInHref(next)}>
          {signInLabel()}
        </a>
      </p>
    </Hero>
  );
}
